import Indisponibilidade, {
  FinderIndisponibilidades,
  RetornoIndisponibilidade
} from 'Interface/Indisponibilidades';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'Indisponibilidades';

const url = '/indisponibilidades';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarIndisponibilidades: construtor.query<
        FinderIndisponibilidades,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.indisponibilidades
            ? [
                ...resultado.indisponibilidades.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarIndisponibilidade: construtor.query<
        RetornoIndisponibilidade,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarIndisponibilidade: construtor.mutation<
        Indisponibilidade,
        Partial<Indisponibilidade>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: dados,
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarIndisponibilidade: construtor.mutation<
        Indisponibilidade,
        Partial<Indisponibilidade> &
          Pick<Indisponibilidade, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'PUT',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerIndisponibilidade: construtor.mutation<
        Indisponibilidade,
        Partial<Indisponibilidade> & Pick<Indisponibilidade, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'DELETE'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarIndisponibilidadesQuery,
  useRecuperarIndisponibilidadeQuery,
  useAdicionarIndisponibilidadeMutation,
  useEditarIndisponibilidadeMutation,
  useRemoverIndisponibilidadeMutation,
} = apiExtendida;
